import Component from "flow/Component";
import componentCache from "flow/utils/componentCache";
import manifestManager from "flow/utils/manifestManager";
import MyFlow from "flow/MyFlow";

let counter = 0;
const id_prefix = "internal-component-";

function createComponent(myFlow: MyFlow, viewModelId: string, viewUrl: string, reuseMyFlow: boolean): Component {
    return new Component(
        {
            baseUrl: myFlow.baseUrl,
            moduleId: myFlow.manifest.moduleId,
            id: id_prefix + ++counter,
            name: myFlow.manifest.name,
            viewModelId: viewModelId,
            viewUrl: viewUrl,
            useFormValidation: false,
            useValidationV3: true,
            isEmbedded: true
        },
        function dummyRemoval() {},
        reuseMyFlow ? myFlow : undefined
    );
}

function createComponentFromId(id: string, rootMyFlow: MyFlow): Component {
    if (rootMyFlow) {
        const manifest = manifestManager.getManifestWithId(id);
        return createComponentFromManifest(rootMyFlow, manifest);
    }
    return componentCache.getComponentById(id);
}

function createComponentFromManifest(myFlow: MyFlow, manifest: any): Component {
    return new Component(manifest, function dummyRemoval() {}, myFlow.rootComponent.myFlow);
}

export default {
    createComponent: createComponent,
    createComponentFromId: createComponentFromId,
    createComponentFromManifest: createComponentFromManifest
};
